import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ["days", "hours", "minutes", "seconds"];

    connect() {
        this.calculateTimeRemaining();
        this.startCountdown();
    }

    calculateTimeRemaining() {
        var endingDate = new Date(this.element.dataset.countdownEnding);
        var currentDate = new Date();
        var timeRemaining = Math.max(0, endingDate - currentDate);

        this.time = {
            days: Math.floor(timeRemaining / (1000 * 60 * 60 * 24)),
            hours: Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
            minutes: Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60)),
            seconds: Math.floor((timeRemaining % (1000 * 60)) / 1000)
        };
    }

    startCountdown() {
        this.updateCountdown();
        setInterval(() => {
            this.calculateTimeRemaining();
            this.updateCountdown();
        }, 1000);
    }

    updateCountdown() {
        this.daysTarget.textContent = this.formatNumber(this.time.days);
        this.hoursTarget.textContent = this.formatNumber(this.time.hours);
        this.minutesTarget.textContent = this.formatNumber(this.time.minutes);
        this.secondsTarget.textContent = this.formatNumber(this.time.seconds);
    }

    formatNumber(number) {
        return number.toString().padStart(2, "0");
    }
}


